module.exports = __webpack_public_path__ + "img/x.9e8b9998.svg";